// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38LPO","questions":"styles_questions__12EEW","footer":"styles_footer__1uyn_"};